import React, {useEffect} from "react";
import {Dialog} from "@material-ui/core";
import {Button} from "../../Button";
import advantagesImage from "../../../images/advantages.svg";
import {ReactSVG} from "react-svg";
import "./Index.scss";
import {strings} from "../../../strings/strings";

export const ApplicationAcceptedDialog = ({open}) => {
    useEffect(() => {
        if (open) {
            let event = 'osago_emtpl_smart_pop_up';
            console.log('Google Analytics Event = ' + event);
            // @ts-ignore
            window.dataLayer.push({'event': event});
        }
    }, [open]);

    return (
        <Dialog open={open} disableBackdropClick={true}>
            <div className={"dialog application-accepted-dialog"}>
                <div className="dialog__content">
                    <ReactSVG src={advantagesImage} style={{alignSelf: 'center'}}/>
                    <span className={"dialog__title"}>{strings.appAcceptedDlg.text1}</span>

                    <p className={"dialog__message"}>
                        {strings.appAcceptedDlg.text2}
                    </p>

                    <Button label={`На головну`} onClickListener={() =>
                        window.location.replace(strings.refs.avtocivilka)
                    }/>
                </div>

                <div className='application-accepted-dialog__note'>
                    {strings.appAcceptedDlg.text3}<span>{strings.appAcceptedDlg.text4}</span>{strings.appAcceptedDlg.text5}
                </div>
            </div>
        </Dialog>
    )
}
